import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Create/update one postnatal baby observation (KIN-1075). Body is a
// PostNatalConsultationBabyObservationDTO (must include postNatalConsultationId
// + foetusId). The consultation form saves the consultation first, then calls
// this once per foetus.
export const useSaveBabyObservation = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async (observation) => {
      const axios = createAxiosInstance();
      const response = await axios.post(
        `${tenantVal}/postnatalconsultationbabyobservation`,
        observation
      );

      return response.data?.data ?? response.data;
    },
    onSuccess: (_data, observation) => {
      queryClient.invalidateQueries({
        queryKey: [
          "postnatalBabyObservations",
          observation?.postNatalConsultationId,
          tenantVal,
        ],
      });
      queryClient.invalidateQueries({ queryKey: ["postNatalConsultations"] });
    },
  });
};
